import React, { useState } from "react";
import InventoryDistribution from "./InventoryDistribution";
import UnitWiseSell from "./UnitWiseSell";
import SmallReportOption from "./SmallReportOption";
import SellableVsNonSellable from "./SellableVsNonSellable";
import LineChart from "./LineChart";
import { MdBarChart } from "react-icons/md";
import { FaDollarSign } from "react-icons/fa";
import ComparePopUp from "./ComparePopUp";
import Dropshadow from "../UIResuableComponents/Dropshadow";
function Reports() {
  const [openComparePopUp, setOpenComparePopUp] = useState(false);
  const openComparePopUpToggle = () => {
    setOpenComparePopUp(true);
  };
  const closeComparePopUpToggle = () => {
    setOpenComparePopUp(false);
  };
  return (
    <div className="mt-10 h-full flex w-full flex-col items-center lg:flex-row lg:flex-wrap md:flex-col md:items-center md:flex-nowrap md:items-start lg:items-start  text-textLightBlack">
      {openComparePopUp && (
        <ComparePopUp closeComparePopUpToggle={closeComparePopUpToggle} />
      )}
      {openComparePopUp && (
        <Dropshadow
          dropDownStyle={"!z-30"}
          onDropDownToggle={closeComparePopUpToggle}
        />
      )}
      <div className="w-[100%] flex flex-col sm:flex-row   items-start mb-6">
        <SmallReportOption title="Amount of Leaves" value="3000">
          <MdBarChart />
        </SmallReportOption>
        <SmallReportOption title="Total Production" value="$642.39">
          <FaDollarSign />
        </SmallReportOption>
        <SmallReportOption
          title="Sales"
          value="$574.34"
          percentage="+23%"
          time="since last month"
        ></SmallReportOption>
      </div>
      <div className="w-[100%] md:w-[100%] lg:w-[48%] lg:mr-2">
        <UnitWiseSell
          openComparePopUpToggle={openComparePopUpToggle}
          customCss={"mb-2"}
        />
      </div>
      <div className="w-[100%]  md:w-[100%] lg:w-[48%]  lg:mr-2">
        <LineChart
          openComparePopUpToggle={openComparePopUpToggle}
          customCss={" mb-2"}
        />
      </div>
      <div className="w-[100%]  md:w-[100%] lg:w-[48%]  lg:mr-2">
        <SellableVsNonSellable
          openComparePopUpToggle={openComparePopUpToggle}
          customCss={"mb-2"}
        />
      </div>
      <div className="w-[100%]  md:w-[100%] lg:w-[48%]  lg:mr-2">
        <InventoryDistribution
          openComparePopUpToggle={openComparePopUpToggle}
          customCss={"mb-2 "}
        />
      </div>
    </div>
  );
}

export default Reports;
